import DOMPurify from 'dompurify';
/**
 * Sanitize Knock's server-rendered feed HTML before it is injected via
 * `dangerouslySetInnerHTML`. The body comes from `feedItemBodyHtml` (Knock's
 * `rendered` output) and can embed values such as `producer_name` that a
 * salesperson sets but a *coach* views — a privilege-crossing surface — so it
 * is sanitized regardless of Knock's own escaping (SCO-406). Kept as a tiny
 * named boundary so the XSS guard is explicit and unit-testable (DOMPurify
 * needs a DOM, so its test runs under the jsdom environment).
 */
export default function sanitizeFeedHtml(html) {
    return DOMPurify.sanitize(html);
}
